var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfitsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "2.01rem",
    viewBox: "0 0 35.097 35.056",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgexport-10",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3888",
    "data-name": "Path 3888",
    d: "M207.175,347.35a.675.675,0,1,0-.675-.675A.675.675,0,0,0,207.175,347.35Zm0,0",
    transform: "translate(-192.596 -322.647)",
    fill: "#199b8b",
    stroke: "#199b8b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3889",
    "data-name": "Path 3889",
    d: "M.7,26.26l8.1,8.1a.675.675,0,0,0,.954,0L14.205,29.9a.675.675,0,0,0,0-.954l-.2-.2h9.729a3.367,3.367,0,0,0,2.3-.9l8.188-7.674a2.606,2.606,0,0,0-3.154-4.119l-1.818,1.193a11.349,11.349,0,0,0-5.267-9.316,2.028,2.028,0,0,0-.895-3.257l-.1-.031,1.737-3.121a.675.675,0,0,0-.4-.976,13.839,13.839,0,0,0-7.7,0,.675.675,0,0,0-.4.977l1.737,3.121-.1.032a2.025,2.025,0,0,0-.891,3.256A11.35,11.35,0,0,0,11.7,17.278c0,.1,0,.2.006.293A8.294,8.294,0,0,0,8.431,19.33L6.38,21.124l-.274-.274a.675.675,0,0,0-.954,0L.7,25.305a.675.675,0,0,0,0,.954ZM17.834,1.632a12.517,12.517,0,0,1,5.287,0l-1.5,2.7a8.229,8.229,0,0,0-2.279,0Zm.451,4.325a6.984,6.984,0,0,1,4.383,0A.675.675,0,0,1,22.5,7.272a6.6,6.6,0,0,0-4.044,0h0a.674.674,0,0,1-.17-1.314Zm.373,2.669A5.266,5.266,0,0,1,22.214,8.6C25.35,9.677,27.9,13.57,27.9,17.278a6.5,6.5,0,0,1-.059.894L24.6,20.3a2.684,2.684,0,0,0-2.1-1h-1.35v-.791a2.025,2.025,0,0,0-.675-3.934.675.675,0,1,1,0-1.35,1.084,1.084,0,0,1,.73.353.675.675,0,1,0,.939-.97,2.6,2.6,0,0,0-.994-.621V11.2a.675.675,0,1,0-1.35,0v.791a2.025,2.025,0,0,0,.675,3.934.675.675,0,0,1,0,1.35,1.221,1.221,0,0,1-.876-.511.675.675,0,0,0-1.033.869,2.8,2.8,0,0,0,1.235.879V19.3h-.225c-.332,0-.481-.216-.714-.367a8.28,8.28,0,0,0-5.81-1.615c0-.014,0-.028,0-.043,0-3.656,2.515-7.537,5.605-8.651ZM9.32,20.345a6.94,6.94,0,0,1,8.733-.33,2.394,2.394,0,0,0,1.524.637H22.5a1.35,1.35,0,0,1,0,2.7H17.777a.675.675,0,0,0,0,1.35H22.5a2.7,2.7,0,0,0,2.66-3.157L31.79,17.2A1.256,1.256,0,0,1,33.3,19.187l-8.188,7.674a2.019,2.019,0,0,1-1.378.541H12.657L7.336,22.081ZM5.629,22.282l7.145,7.145-3.5,3.5L2.129,25.782Zm0,0",
    transform: "translate(-0.499 0)",
    fill: "#199b8b",
    stroke: "#199b8b",
    strokeWidth: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitsIcon);
export default __webpack_public_path__ + "static/media/profits-icon.a8e02db6de023351817b85920bad82e0.svg";
export { ForwardRef as ReactComponent };